import { createContext, useContext } from 'react';

export type DashboardSidebarContextProps = {
  isMobileSize: boolean;
  sidebarExpanded: boolean;
};

export const dashboardSidebarCtx =
  createContext<DashboardSidebarContextProps | null>(null);

export const useDashboardSidebarCtx = () => {
  const ctx = useContext(dashboardSidebarCtx);
  if (!ctx) {
    throw new Error(
      'useDashboardSidebarCtx must be used within DashboardSidebar.Root',
    );
  }

  return ctx;
};
